module.exports = __webpack_public_path__ + "img/inbrands.3cc49382.svg";